// src/api/axiosInstance.js
import axios from 'axios';
import { crmApiBaseUrl } from '../utils/config';
const axiosInstance = axios.create({
  // baseURL:'https://backend.pfxinvestments.com/api',
  baseURL:'https://crm.sundreamcapital.com/api',
  // baseURL:crmApiBaseUrl ,
});



axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;
    